import { render, staticRenderFns } from "./CartWorkspaces.vue?vue&type=template&id=7a5e3ca1"
import script from "./CartWorkspaces.vue?vue&type=script&lang=js"
export * from "./CartWorkspaces.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports